/*import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PropTypes from "prop-types";
export default function ActionsMenu({ row, onEdit, onDelete }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Button
        variant="contained"
        size="small"
        startIcon={<MoreVertIcon />}
        sx={{
          backgroundColor: "#1976d2",
          color: "#fff",
          textTransform: "none",
          "&:hover": { backgroundColor: "#115293" },
        }}
        onClick={handleClick}
      >
        Actions
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            handleClose();
            onEdit(row);
          }}
          sx={{
            minWidth: "50px",
            color: "blue", // text color
            "&:hover": {
              backgroundColor: "rgba(0, 0, 255, 0.1)", // light blue hover
            },
          }}
        >
          <EditIcon fontSize="small" style={{ marginRight: 8 }} />
          Edit
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleClose();
            onDelete(row);
          }}
          sx={{
            minWidth: "100px",
            color: "red", // text color
            "&:hover": {
              backgroundColor: "rgba(255, 0, 0, 0.1)", // light red hover
            },
          }}
        >
          <DeleteIcon fontSize="small" style={{ marginRight: 8 }} />
          Delete
        </MenuItem>
      </Menu>
    </>
  );
}
ActionsMenu.propTypes = {
  row: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
*/
import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PropTypes from "prop-types";
import MapIcon from "@mui/icons-material/AccountTree"; // any icon you like

export default function ActionsMenu({ row, onEdit, onDelete, onMapRegulation }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <>
      <Button
        variant="contained"
        size="small"
        startIcon={<MoreVertIcon />}
        sx={{
          backgroundColor: "#1976d2",
          color: "#fff",
          textTransform: "none",
          "&:hover": { backgroundColor: "#115293" },
        }}
        onClick={handleClick}
      >
        Actions
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {/* Existing Edit */}
        <MenuItem
          onClick={() => {
            handleClose();
            onEdit(row);
          }}
          sx={{ minWidth: "50px", color: "blue" }}
        >
          <EditIcon fontSize="small" style={{ marginRight: 8 }} />
          Edit Batch
        </MenuItem>
        {/* Existing Delete */}
        <MenuItem
          onClick={() => {
            handleClose();
            onDelete(row);
          }}
          sx={{ minWidth: "100px", color: "red" }}
        >
          <DeleteIcon fontSize="small" style={{ marginRight: 8 }} />
          Delete Batch
        </MenuItem>
        {/* New Map Regulation */}
        <MenuItem
          onClick={() => {
            handleClose();
            onMapRegulation(row);
          }}
          sx={{ minWidth: "100px", color: "green" }}
        >
          <MapIcon fontSize="small" style={{ marginRight: 8 }} />
          Map Regulation
        </MenuItem>
      </Menu>
    </>
  );
}

ActionsMenu.propTypes = {
  row: PropTypes.object.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onMapRegulation: PropTypes.func.isRequired, // new prop
};
